<!-- mail-workflow-detail.component.html -->

<div class="mwd-page" *ngIf="!loading && task; else loadingTpl">

  <sp-header></sp-header>

  <!-- ══════════ TASK HEADER ══════════ -->
  <div class="mwd-header">
    <div class="mwd-header-left">
      <button class="mwd-back" (click)="router.navigate(['/workflow'])" title="Back">
        <span class="material-icons">arrow_back</span>
      </button>
      <span class="material-icons" [style.color]="mailTypeColor" style="font-size:24px;flex-shrink:0">
        {{ mailTypeIcon }}
      </span>
      <div class="mwd-title-block">
        <h1>
          <span class="mwd-ref">{{ task.referenceNumber || '—' }}</span>
          {{ task.subject }}
        </h1>
        <div class="mwd-sub">
          {{ mailTypeLabel }}
          <span *ngIf="task.fileClassName">· {{ task.fileClassName }}</span>
          <span *ngIf="task.fromName">
            · From: <strong>{{ task.fromName }}</strong>
            <span *ngIf="task.fromOrganization">, {{ task.fromOrganization }}</span>
          </span>
          <span *ngIf="task.dueDate" [style.color]="task.overdue ? '#dc3545' : '#6c757d'">
            · Due: <strong>{{ task.dueDate | date:'d MMM yyyy' }}</strong>
            <span *ngIf="task.overdue" style="font-weight:700"> ⚠ OVERDUE</span>
          </span>
        </div>
      </div>
    </div>
    <div class="mwd-header-right">
      <span class="mwd-badge" [style.background]="priorityColor">{{ task.priority }}</span>
      <span class="mwd-badge large" [style.background]="stageColor">{{ task.currentStage }}</span>
      <span *ngIf="error"      class="mwd-alert error">  <span class="material-icons">error</span>{{ error }}</span>
      <span *ngIf="successMsg" class="mwd-alert success"><span class="material-icons">check_circle</span>{{ successMsg }}</span>
    </div>
  </div>

  <!-- ══════════ SPLIT ══════════ -->
  <div class="mwd-split">

    <!-- ╔════════════════════════════╗
         ║   LEFT — Document (~60%)  ║
         ╚════════════════════════════╝ -->
    <div class="mwd-left">
      <div class="mwd-tabs">
        <button class="mwd-tab" [class.active]="leftTab === 'viewer'" (click)="leftTab = 'viewer'">
          <span class="material-icons">picture_as_pdf</span> Document
        </button>
        <button class="mwd-tab" [class.active]="leftTab === 'filebrowser'"
                (click)="leftTab = 'filebrowser'; loadFileBrowser()">
          <span class="material-icons">folder_open</span> File Folio
        </button>
      </div>

      <!-- DOCUMENT viewer -->
      <ng-container *ngIf="leftTab === 'viewer'">
        <div class="mwd-viewer-toolbar">
          <div class="mwd-doc-name">
            <span class="material-icons">description</span>
            <span>{{ activeViewerName }}</span>
          </div>
          <a class="sp-btn sp-btn-outline sp-btn-xs"
             [href]="'/api/mail/workflow/' + activeViewerNodeId + '/content'"
             download>
            <span class="material-icons">download</span> Download
          </a>
        </div>
        <div class="mwd-viewer-frame" *ngIf="!viewerLoading && !viewerError && viewerBlobUrl">
          <iframe [src]="viewerBlobUrl" title="Document preview"></iframe>
        </div>
        <div class="mwd-viewer-loading" *ngIf="viewerLoading">
          <div class="mwd-spinner"></div>
          <span>Loading document…</span>
        </div>
        <div class="mwd-viewer-empty" *ngIf="!viewerLoading && viewerError">
          <span class="material-icons">broken_image</span>
          <p>{{ viewerError }}</p>
          <button class="sp-btn sp-btn-outline sp-btn-sm"
                  (click)="task && loadDocumentBlob(task.documentNodeId)">
            <span class="material-icons">refresh</span> Retry
          </button>
        </div>
        <div class="mwd-viewer-empty" *ngIf="!viewerLoading && !viewerError && !viewerBlobUrl">
          <span class="material-icons">description</span>
          <p>No document attached.</p>
        </div>
      </ng-container>

      <!-- FILE FOLIO tab -->
      <div class="mwd-tab-body mwd-tab-pad" *ngIf="leftTab === 'filebrowser'">

        <!-- Header: file reference info + order toggle -->
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:wrap">
          <div style="flex:1">
            <span style="font-size:11px;color:#6c757d">
              File Reference:
              <strong *ngIf="task.fileReferenceNo">{{ task.fileReferenceNo }}</strong>
              <span *ngIf="!task.fileReferenceNo && task.fileClassCode">
                Class <strong>{{ task.fileClassCode }}</strong>
              </span>
              <span *ngIf="!task.fileReferenceNo && !task.fileClassCode" style="color:#aab5c5">— not set —</span>
            </span>
          </div>
          <button class="sp-btn-icon-sm" title="Toggle order" (click)="toggleFolioOrder()"
                  *ngIf="fileBrowserFolios.length">
            <span class="material-icons" style="font-size:14px">
              {{ fileBrowserOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
            </span>
            {{ fileBrowserOrder === 'asc' ? 'Oldest first' : 'Newest first' }}
          </button>
        </div>

        <div *ngIf="!task.fileReferenceId" class="mwd-empty">
          <span class="material-icons">folder_off</span>
          <span>No file reference assigned to this document.</span>
        </div>

        <div *ngIf="task.fileReferenceId && fileBrowserLoading" class="mwd-empty">
          <span class="material-icons">hourglass_top</span><span>Loading folios…</span>
        </div>

        <table class="mwd-docs-table" *ngIf="task.fileReferenceId && !fileBrowserLoading && fileBrowserFolios.length">
          <thead>
            <tr>
              <th style="width:40px">Folio</th>
              <th>Ref No.</th>
              <th>Subject</th>
              <th style="width:80px">Type</th>
              <th style="width:70px">Stage</th>
              <th style="width:65px">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of fileBrowserFolios"
                [class.mwd-row-active]="f.documentNodeId === task.documentNodeId"
                style="cursor:pointer"
                (click)="f.documentNodeId && openDocInViewer(f.documentNodeId, f.referenceNumber)">
              <td style="font-weight:700;color:#244062;text-align:center">{{ f.folio }}</td>
              <td style="font-family:monospace;font-size:11px;white-space:nowrap">{{ f.referenceNumber }}</td>
              <td style="max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
                  [title]="f.subject">{{ f.subject }}</td>
              <td>
                <span class="mwd-mini-badge"
                  [style.background]="f.mailType==='INCOMING'?'#e3f0ff':f.mailType==='OUTGOING'?'#e8f8f2':'#fff3e0'"
                  [style.color]="f.mailType==='INCOMING'?'#244062':f.mailType==='OUTGOING'?'#0D7A5F':'#D46B08'">
                  {{ f.mailType === 'INTERNAL_MEMO' ? 'MEMO' : f.mailType }}
                </span>
              </td>
              <td>
                <span class="mwd-mini-badge"
                  [style.background]="f.currentStage==='INBOX'?'#e3f0ff':f.currentStage==='ARCHIVED'?'#f0f0f0':'#fff3e0'"
                  [style.color]="f.currentStage==='INBOX'?'#2B5CB8':f.currentStage==='ARCHIVED'?'#6c757d':'#D46B08'">
                  {{ f.currentStage }}
                </span>
              </td>
              <td style="font-size:10px;color:#8a9bb0;white-space:nowrap">
                {{ f.startedAt | date:'d MMM yy' }}
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="task.fileReferenceId && !fileBrowserLoading && !fileBrowserFolios.length" class="mwd-empty">
          <span class="material-icons">folder_open</span>
          <span>No documents filed under this reference yet.</span>
        </div>
      </div>
    </div><!-- /mwd-left -->


    <!-- ╔═══════════════════════════════════╗
         ║  RIGHT — Metadata+Actions (~40%) ║
         ╚═══════════════════════════════════╝ -->
    <div class="mwd-right">

      <!-- BRING-UP notice -->
      <div class="mwd-bringup-notice" *ngIf="task.activeBringup">
        <div class="mwd-bringup-head">
          <span class="material-icons">alarm</span> Bring-Up Active
        </div>
        <div class="mwd-bringup-body">
          <ng-container *ngIf="task.activeBringup.bringupType === 'DATE'">
            Scheduled for <strong>{{ task.activeBringup.bringupDate | date:'d MMM yyyy HH:mm' }}</strong>
          </ng-container>
          <ng-container *ngIf="task.activeBringup.bringupType === 'CONDITION'">
            Condition: <strong>{{ task.activeBringup.conditionNote }}</strong>
          </ng-container>
          <button class="sp-btn sp-btn-primary sp-btn-xs" style="margin-top:8px;display:block"
                  (click)="releaseBringup()" [disabled]="submitting">
            <span class="material-icons">alarm_on</span> Release Now
          </button>
        </div>
      </div>

      <!-- ══ MAIL DETAILS ══ -->
      <div class="mwd-acc">
        <div class="mwd-acc-head" (click)="accMeta = !accMeta">
          <span class="material-icons">{{ accMeta ? 'expand_more' : 'chevron_right' }}</span>
          <span class="material-icons">info</span>
          <span class="mwd-acc-title">Mail Details</span>
        </div>
        <div class="mwd-acc-body" *ngIf="accMeta">
          <div class="mwd-detail-grid">
            <div class="mwd-field">
              <label>Mail Type</label>
              <div class="mwd-field-value">{{ mailTypeLabel }}</div>
            </div>
            <div class="mwd-field">
              <label>File Class</label>
              <div class="mwd-field-value">{{ task.fileClassCode }} — {{ task.fileClassName }}</div>
            </div>
            <div class="mwd-field" *ngIf="task.fromName">
              <label>From</label>
              <div class="mwd-field-value">{{ task.fromName }}</div>
            </div>
            <div class="mwd-field" *ngIf="task.fromOrganization">
              <label>Organisation</label>
              <div class="mwd-field-value">{{ task.fromOrganization }}</div>
            </div>
            <div class="mwd-field" *ngIf="task.fromEmail">
              <label>Email</label>
              <div class="mwd-field-value">{{ task.fromEmail }}</div>
            </div>
            <div class="mwd-field" *ngIf="task.dateOfMail">
              <label>Date of Mail</label>
              <div class="mwd-field-value">{{ task.dateOfMail | date:'d MMM yyyy' }}</div>
            </div>
            <div class="mwd-field" *ngIf="task.externalReference">
              <label>Ext. Reference</label>
              <div class="mwd-field-value">{{ task.externalReference }}</div>
            </div>
            <div class="mwd-field" *ngIf="task.dueDate">
              <label>Due Date</label>
              <div class="mwd-field-value" [style.color]="task.overdue ? '#dc3545' : ''">
                {{ task.dueDate | date:'d MMM yyyy' }}
                <span *ngIf="task.overdue" style="font-weight:700"> ⚠</span>
              </div>
            </div>
            <div class="mwd-field" *ngIf="task.deadlineAt">
              <label>Deadline</label>
              <div class="mwd-field-value">{{ task.deadlineAt | date:'d MMM yyyy HH:mm' }}</div>
            </div>
            <div class="mwd-field span2" *ngIf="task.instructions">
              <label>Instructions</label>
              <div class="mwd-field-value" style="white-space:pre-wrap">{{ task.instructions }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══ WORKFLOW DOCUMENTS ══ -->
      <div class="mwd-acc">
        <div class="mwd-acc-head" (click)="accDocs = !accDocs">
          <span class="material-icons">{{ accDocs ? 'expand_more' : 'chevron_right' }}</span>
          <span class="material-icons">folder_copy</span>
          <span class="mwd-acc-title">Workflow Documents</span>
          <span class="mwd-acc-count" *ngIf="workflowDocs.length">{{ workflowDocs.length }}</span>
        </div>
        <div style="padding:0" *ngIf="accDocs">
          <div class="mwd-docs-toolbar">
            <span style="font-size:11px;color:#6c757d">Documents in this workflow</span>
            <label class="mwd-file-label" [class.uploading]="uploadingDoc">
              <span class="material-icons">upload_file</span>
              {{ uploadingDoc ? 'Uploading…' : 'Add' }}
              <input type="file" style="display:none" [disabled]="uploadingDoc"
                     accept=".pdf,.doc,.docx,.tiff,.jpg,.jpeg,.png"
                     (change)="onAddDocumentSelected($event)">
            </label>
          </div>
          <div *ngIf="uploadDocError" class="mwd-upload-error">{{ uploadDocError }}</div>
          <div *ngIf="docsLoading" class="mwd-empty" style="padding:14px">
            <span class="material-icons">hourglass_top</span><span>Loading…</span>
          </div>

          <div class="mwd-doc-row"
               *ngFor="let doc of pagedDocs"
               [class.mwd-doc-row--active]="doc.nodeId === activeViewerNodeId"
               (click)="openDocInViewer(doc.nodeId, doc.name)">
            <span class="material-icons mwd-doc-row-icon" [style.color]="docIconColor(doc)">
              {{ docIcon(doc) }}
            </span>
            <div class="mwd-doc-row-info">
              <span class="mwd-doc-row-name">{{ doc.name }}</span>
              <span class="mwd-doc-row-meta">{{ formatSize(doc.size) }} · {{ doc.createdAt | date:'d MMM yyyy' }}</span>
            </div>
            <span *ngIf="doc.isPrimary" class="mwd-primary-tag">PRIMARY</span>
            <span *ngIf="doc.nodeId === activeViewerNodeId" class="mwd-viewing-tag">VIEWING</span>
            <button class="mwd-sign-btn"
                    title="Sign this document"
                    [disabled]="signingInProgress || !task.myTask || !task.documentNodeId"
                    (click)="$event.stopPropagation(); signDocument()">
              <span class="material-icons">draw</span>
            </button>
          </div>

          <div *ngIf="!docsLoading && workflowDocs.length === 0 && !docsLoadError" class="mwd-empty" style="padding:14px">
            <span class="material-icons">description</span><span>No documents yet.</span>
          </div>

          <!-- Pagination -->
          <div class="mwd-docs-pager" *ngIf="docsTotalPages > 1">
            <button class="sp-btn-icon-sm" (click)="docsPrevPage()" [disabled]="docsPage === 1">
              <span class="material-icons">chevron_left</span>
            </button>
            <span style="font-size:11px;color:#6c757d">
              {{ docsPage }} / {{ docsTotalPages }} ({{ workflowDocs.length }})
            </span>
            <button class="sp-btn-icon-sm" (click)="docsNextPage()" [disabled]="docsPage === docsTotalPages">
              <span class="material-icons">chevron_right</span>
            </button>
          </div>
        </div>
      </div>

      <!-- ══ DISPATCH TRAIL ══ -->
      <div class="mwd-acc" *ngIf="task.participants?.length">
        <div class="mwd-acc-head" (click)="accTrail = !accTrail">
          <span class="material-icons">{{ accTrail ? 'expand_more' : 'chevron_right' }}</span>
          <span class="material-icons">people</span>
          <span class="mwd-acc-title">Dispatch Trail</span>
          <span class="mwd-acc-count">{{ task.participants.length }}</span>
        </div>
        <div class="mwd-acc-body" *ngIf="accTrail">
          <div class="mwd-trail-card"
               *ngFor="let p of task.participants"
               [class.completed]="p.status === 'COMPLETED'"
               [class.active]="p.status === 'ACTIVE' || p.status === 'PENDING'">
            <div class="mwd-trail-head">
              <span class="material-icons" [style.color]="p.status === 'COMPLETED' ? '#28a745' : '#4A90D9'">
                {{ p.status === 'COMPLETED' ? 'check_circle' : 'radio_button_unchecked' }}
              </span>
              <span class="mwd-role">{{ p.role }}</span>
              <span class="mwd-trail-status"
                    [style.background]="p.status === 'COMPLETED' ? '#28a745' : '#6c757d'">
                {{ p.status }}
              </span>
            </div>
            <div class="mwd-trail-user">
              <span class="material-icons">person</span>
              {{ p.displayName || p.username }}
              <span *ngIf="p.groupName" style="font-weight:normal;color:#6c757d;font-size:11px">
                · {{ p.groupName }}
              </span>
            </div>
            <div *ngIf="p.instructions" class="mwd-trail-note">
              <span class="material-icons">notes</span>{{ p.instructions }}
            </div>
          </div>
        </div>
      </div>

      <!-- ══ ACTIONS ══ -->
      <div class="mwd-acc" *ngIf="isMyTask">
        <div class="mwd-acc-head" (click)="accActions = !accActions">
          <span class="material-icons">{{ accActions ? 'expand_more' : 'chevron_right' }}</span>
          <span class="material-icons">touch_app</span>
          <span class="mwd-acc-title">Actions</span>
        </div>
        <div class="mwd-acc-body" *ngIf="accActions">

          <div class="mwd-action-tabs">
            <button *ngIf="isDispatchTask" class="sp-btn sp-btn-sm"
                    [class.sp-btn-primary]="activeTab === 'dispatch'"
                    [class.sp-btn-outline]="activeTab !== 'dispatch'"
                    (click)="setTab('dispatch')">
              <span class="material-icons">send</span> Dispatch
            </button>
            <ng-container *ngIf="isInboxTask">
              <button class="sp-btn sp-btn-sm"
                      [class.sp-btn-primary]="activeTab === 'forward'"
                      [class.sp-btn-outline]="activeTab !== 'forward'"
                      (click)="setTab('forward')">
                <span class="material-icons">forward_to_inbox</span> Forward
              </button>
              <button class="sp-btn sp-btn-sm"
                      [class.sp-btn-primary]="activeTab === 'bringup'"
                      [class.sp-btn-outline]="activeTab !== 'bringup'"
                      (click)="setTab('bringup')">
                <span class="material-icons">schedule</span> Bring-Up
              </button>
              <button class="sp-btn sp-btn-sm"
                      [class.sp-btn-primary]="activeTab === 'split'"
                      [class.sp-btn-outline]="activeTab !== 'split'"
                      (click)="setTab('split')">
                <span class="material-icons">call_split</span> Split
              </button>
              <button class="sp-btn sp-btn-sm"
                      [class.sp-btn-primary]="activeTab === 'outgoing'"
                      [class.sp-btn-outline]="activeTab !== 'outgoing'"
                      (click)="setTab('outgoing')">
                <span class="material-icons">reply</span> Reply
              </button>
              <button class="sp-btn sp-btn-sm"
                      [class.sp-btn-primary]="activeTab === 'sign'"
                      [class.sp-btn-outline]="activeTab !== 'sign'"
                      (click)="setTab('sign')">
                <span class="material-icons">draw</span> Sign
              </button>
            </ng-container>
          </div>

          <!-- DISPATCH -->
          <div *ngIf="activeTab === 'dispatch'">
            <div class="mwd-detail-grid">
              <div class="mwd-field">
                <label>Recipient Username <span style="color:#dc3545">*</span></label>
                <input class="mwd-input" [(ngModel)]="dispatchTo" placeholder="e.g. jdoe">
              </div>
              <div class="mwd-field">
                <label>Display Name</label>
                <input class="mwd-input" [(ngModel)]="dispatchToName">
              </div>
              <div class="mwd-field">
                <label>Email</label>
                <input class="mwd-input" [(ngModel)]="dispatchToEmail" type="email">
              </div>
              <div class="mwd-field">
                <label>Group (optional)</label>
                <input class="mwd-input" [(ngModel)]="dispatchToGroup">
              </div>
              <div class="mwd-field span2">
                <label>Instructions</label>
                <textarea class="mwd-input" [(ngModel)]="instructions" rows="2"></textarea>
              </div>
              <div class="mwd-field">
                <label>Deadline</label>
                <input class="mwd-input" [(ngModel)]="deadlineAt" type="datetime-local">
              </div>
              <div class="mwd-field">
                <label>Escalate To</label>
                <input class="mwd-input" [(ngModel)]="escalateTo" placeholder="Username">
              </div>
            </div>
            <button class="sp-btn sp-btn-primary sp-btn-sm" style="margin-top:10px"
                    (click)="completeDispatch()" [disabled]="submitting">
              <span class="material-icons">send</span>
              {{ submitting ? 'Dispatching…' : 'Dispatch Mail' }}
            </button>
          </div>

          <!-- FORWARD with typeahead -->
          <div *ngIf="activeTab === 'forward'">
            <div class="mwd-toggle-row">
              <button class="sp-btn sp-btn-xs"
                      [class.sp-btn-primary]="!forwardIsGroup" [class.sp-btn-outline]="forwardIsGroup"
                      (click)="forwardIsGroup=false; forwardGroupResults=[]; forwardUserResults=[]">
                <span class="material-icons">person</span> User
              </button>
              <button class="sp-btn sp-btn-xs"
                      [class.sp-btn-primary]="forwardIsGroup" [class.sp-btn-outline]="!forwardIsGroup"
                      (click)="forwardIsGroup=true; forwardUserResults=[]; forwardGroupResults=[]">
                <span class="material-icons">group</span> Group
              </button>
            </div>
            <div class="mwd-detail-grid" style="margin-top:10px">
              <div class="mwd-field span2" style="position:relative">
                <label>{{ forwardIsGroup ? 'Group' : 'User' }} <span style="color:#dc3545">*</span></label>
                <div style="position:relative">
                  <span class="material-icons mwd-search-prefix-icon">search</span>
                  <input class="mwd-input" style="padding-left:30px"
                         [placeholder]="forwardIsGroup ? 'Type group name…' : 'Type name or username…'"
                         [value]="forwardSearchQuery"
                         (input)="onForwardSearchInput($any($event.target).value)"
                         (blur)="$event.relatedTarget ? null : (showForwardDropdown = false)"
                         autocomplete="off">
                  <span *ngIf="forwardSearching" class="material-icons mwd-search-spinner">refresh</span>
                </div>
                <div class="mwd-search-dropdown"
                     *ngIf="showForwardDropdown && (forwardUserResults.length || forwardGroupResults.length)">
                  <div class="mwd-search-item" *ngFor="let u of forwardUserResults"
                       (mousedown)="selectForwardUser(u)">
                    <span class="material-icons mwd-search-icon">person</span>
                    <div class="mwd-search-info">
                      <span class="mwd-search-name">{{ u.displayName }}</span>
                      <span class="mwd-search-sub">{{ u.id }}{{ u.email ? ' · ' + u.email : '' }}</span>
                    </div>
                  </div>
                  <div class="mwd-search-item" *ngFor="let g of forwardGroupResults"
                       (mousedown)="selectForwardGroup(g)">
                    <span class="material-icons mwd-search-icon">group</span>
                    <div class="mwd-search-info">
                      <span class="mwd-search-name">{{ g.displayName }}</span>
                      <span class="mwd-search-sub">{{ g.id }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mwd-field span2" *ngIf="forwardToName && !showForwardDropdown">
                <div class="mwd-selected-pill">
                  <span class="material-icons">{{ forwardIsGroup ? 'group' : 'person' }}</span>
                  <span>{{ forwardToName }}</span>
                  <span *ngIf="forwardToEmail" class="mwd-selected-email"> · {{ forwardToEmail }}</span>
                  <button class="sp-btn-icon-sm" style="margin-left:auto" (click)="clearForwardSelection()">
                    <span class="material-icons">close</span>
                  </button>
                </div>
              </div>
              <div class="mwd-field">
                <label>New Deadline</label>
                <input class="mwd-input" [(ngModel)]="forwardDeadline" type="datetime-local">
              </div>
              <div class="mwd-field">
                <label>Email (override)</label>
                <input class="mwd-input" [(ngModel)]="forwardToEmail" type="email">
              </div>
              <div class="mwd-field span2">
                <label>Note</label>
                <textarea class="mwd-input" [(ngModel)]="forwardNote" rows="2"></textarea>
              </div>
            </div>
            <button class="sp-btn sp-btn-primary sp-btn-sm" style="margin-top:10px"
                    (click)="completeForward()" [disabled]="submitting">
              <span class="material-icons">forward_to_inbox</span>
              {{ submitting ? 'Forwarding…' : 'Forward Mail' }}
            </button>
          </div>

          <!-- BRING-UP -->
          <div *ngIf="activeTab === 'bringup'">
            <div class="mwd-field" style="margin-bottom:10px">
              <label>Bring-Up Type</label>
              <div class="mwd-radio-group">
                <label><input type="radio" [(ngModel)]="bringupType" value="DATE"> Date-based</label>
                <label><input type="radio" [(ngModel)]="bringupType" value="CONDITION"> Condition</label>
              </div>
            </div>
            <div class="mwd-field" *ngIf="bringupType === 'DATE'">
              <label>Date & Time <span style="color:#dc3545">*</span></label>
              <input class="mwd-input" [(ngModel)]="bringupDate" type="datetime-local">
            </div>
            <div class="mwd-field" *ngIf="bringupType === 'CONDITION'">
              <label>Condition <span style="color:#dc3545">*</span></label>
              <textarea class="mwd-input" [(ngModel)]="bringupNote" rows="3"
                        placeholder="Describe the condition…"></textarea>
            </div>
            <button class="sp-btn sp-btn-warning sp-btn-sm" style="margin-top:10px"
                    (click)="completeBringup()" [disabled]="submitting">
              <span class="material-icons">alarm_add</span>
              {{ submitting ? 'Setting…' : 'Set Bring-Up' }}
            </button>
          </div>

          <!-- SPLIT -->
          <div *ngIf="activeTab === 'split'">
            <p style="font-size:11px;color:#6c757d;margin:0 0 10px">
              Each recipient gets their own task linked to this reference.
            </p>
            <div class="mwd-split-card" *ngFor="let r of splitRecipients; let i = index">
              <div class="mwd-split-label">Recipient {{ i + 1 }}</div>
              <button class="sp-btn-icon-sm danger"
                      style="position:absolute;top:8px;right:8px"
                      (click)="removeSplitRecipient(i)">
                <span class="material-icons">close</span>
              </button>
              <div class="mwd-split-grid">
                <input class="mwd-input" [(ngModel)]="r.username" placeholder="Username *">
                <input class="mwd-input" [(ngModel)]="r.email" placeholder="Email *">
                <input class="mwd-input" [(ngModel)]="r.instructions" placeholder="Instructions"
                       style="grid-column:span 2">
              </div>
            </div>
            <button class="sp-btn-add" (click)="addSplitRecipient()">
              <span class="material-icons">add</span> Add Recipient
            </button>
            <button class="sp-btn sp-btn-primary sp-btn-sm"
                    style="margin-top:10px;display:block"
                    (click)="completeSplit()" [disabled]="submitting || !splitValid">
              <span class="material-icons">call_split</span>
              {{ submitting ? 'Splitting…' : 'Split to ' + splitRecipients.length + ' recipient(s)' }}
            </button>
          </div>

          <!-- REPLY (outgoing) -->
          <div *ngIf="activeTab === 'outgoing'">
            <div class="mwd-reply-info">
              <span class="material-icons">info</span>
              <div>A new <strong>Outgoing Mail</strong> workflow will be linked to
                <strong>{{ task.referenceNumber }}</strong>.</div>
            </div>
            <table style="width:100%;border-collapse:collapse;font-size:12px;margin-bottom:12px">
              <tr><td style="color:#6c757d;padding:3px 0;width:90px">In Reply To</td>
                  <td style="font-weight:700;font-family:monospace">{{ task.referenceNumber }}</td></tr>
              <tr><td style="color:#6c757d;padding:3px 0">To Org.</td>
                  <td>{{ task.fromOrganization || task.fromName || '—' }}</td></tr>
              <tr><td style="color:#6c757d;padding:3px 0">Subject</td>
                  <td>RE: {{ task.subject }}</td></tr>
            </table>
            <button class="sp-btn sp-btn-primary sp-btn-sm" (click)="startOutgoingReply()">
              <span class="material-icons">reply</span> Start Outgoing Reply
            </button>
          </div>

          <!-- SIGN — Document signing -->
          <div *ngIf="activeTab === 'sign'">
            <div class="mwd-sign-panel">

              <div class="mwd-sign-header">
                <span class="material-icons" style="color:#2B5CB8">draw</span>
                Sign Document
              </div>

              <!-- Not my task — signing disabled -->
              <div *ngIf="!task.myTask" class="mwd-empty" style="padding:14px 0">
                <span class="material-icons">lock</span>
                <span>Signing is only available when this task is assigned to you.</span>
              </div>

              <ng-container *ngIf="task.myTask">

                <p style="font-size:12px;color:#6c757d;margin:0 0 14px">
                  Clicking <strong>Sign Document</strong> opens the signing portal
                  in a separate window. After you apply your signature and close the portal,
                  the signed copy is saved automatically in Alfresco and the viewer will
                  refresh to show it.
                </p>

                <!-- Signed confirmation -->
                <div *ngIf="hasSigned" class="mwd-sign-active" style="margin-bottom:12px">
                  <span class="material-icons" style="color:#0D7A5F">check_circle</span>
                  Document signed successfully. The viewer has been refreshed with the
                  signed copy from Alfresco.
                </div>

                <!-- Signing in progress -->
                <div *ngIf="signingInProgress"
                     style="display:flex;align-items:center;gap:8px;font-size:12px;
                            color:#6c757d;margin-bottom:12px">
                  <span class="mwd-mini-spinner" style="width:14px;height:14px"></span>
                  Signing portal open — please complete signing in the popup window…
                </div>

                <!-- Sign button -->
                <button class="sp-btn sp-btn-primary sp-btn-sm"
                        [disabled]="signingInProgress"
                        (click)="signDocument()">
                  <span class="material-icons">draw</span>
                  {{ signingInProgress ? 'Signing in progress…' : hasSigned ? 'Sign Again' : 'Sign Document' }}
                </button>

              </ng-container>
            </div>
          </div>

          <!-- Archive strip -->
          <div class="mwd-archive-strip" *ngIf="isInboxTask">
            <input class="mwd-input" [(ngModel)]="actionNote" placeholder="Archive note (optional)…">
            <button class="sp-btn sp-btn-danger sp-btn-sm"
                    (click)="completeArchive()" [disabled]="submitting">
              <span class="material-icons">inventory_2</span>
              {{ submitting ? 'Archiving…' : 'Archive' }}
            </button>
          </div>
        </div>
      </div>

      <!-- ══ COMMENTS ══ -->
      <div class="mwd-acc">
        <div class="mwd-acc-head" (click)="accComments = !accComments">
          <span class="material-icons">{{ accComments ? 'expand_more' : 'chevron_right' }}</span>
          <span class="material-icons">chat</span>
          <span class="mwd-acc-title">Comments</span>
          <span class="mwd-acc-count" *ngIf="task.comments?.length">{{ task.comments.length }}</span>
        </div>
        <div class="mwd-acc-body" *ngIf="accComments">
          <div class="mwd-comment-input">
            <div class="mwd-avatar">{{ currentUserInitials }}</div>
            <div class="mwd-comment-form">
              <div *ngIf="replyingToId" style="font-size:11px;color:#6c757d;margin-bottom:4px">
                Replying… <button class="sp-btn-link" (click)="cancelReply()">Cancel</button>
              </div>
              <textarea [(ngModel)]="newComment" rows="2" placeholder="Add a comment…"></textarea>
              <button class="sp-btn sp-btn-primary sp-btn-xs" style="align-self:flex-end"
                      (click)="submitComment()" [disabled]="!newComment.trim() || submittingComment">
                <span class="material-icons">send</span>
                {{ submittingComment ? 'Posting…' : 'Post' }}
              </button>
            </div>
          </div>
          <div class="mwd-comment" *ngFor="let c of task.comments">
            <div class="mwd-avatar sm">{{ initials(c.authorName || c.authorUsername) }}</div>
            <div class="mwd-comment-body">
              <div class="mwd-comment-header">
                <span class="mwd-author">{{ c.authorName || c.authorUsername }}</span>
                <span class="mwd-time">{{ c.createdAt | date:'d MMM HH:mm' }}</span>
                <button class="sp-btn-link" style="margin-left:auto;font-size:10px" (click)="replyTo(c)">
                  <span class="material-icons" style="font-size:12px">reply</span> Reply
                </button>
              </div>
              <p class="mwd-comment-text">{{ c.content }}</p>
              <div class="mwd-replies" *ngIf="c.replies?.length">
                <div class="mwd-reply" *ngFor="let r of c.replies">
                  <div class="mwd-avatar sm">{{ initials(r.authorName || r.authorUsername) }}</div>
                  <div class="mwd-comment-body">
                    <div class="mwd-comment-header">
                      <span class="mwd-author">{{ r.authorName || r.authorUsername }}</span>
                      <span class="mwd-time">{{ r.createdAt | date:'d MMM HH:mm' }}</span>
                    </div>
                    <p class="mwd-comment-text">{{ r.content }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!task.comments?.length" class="mwd-empty">
            <span class="material-icons">chat_bubble_outline</span><span>No comments yet.</span>
          </div>
        </div>
      </div>

      <!-- ══ RELATED DOCUMENTS ══ -->
      <div class="mwd-acc">
        <div class="mwd-acc-head" (click)="accRelated = !accRelated">
          <span class="material-icons">{{ accRelated ? 'expand_more' : 'chevron_right' }}</span>
          <span class="material-icons">link</span>
          <span class="mwd-acc-title">Related Documents</span>
          <span class="mwd-acc-count" *ngIf="task.relatedDocuments?.length">{{ task.relatedDocuments.length }}</span>
        </div>
        <div class="mwd-acc-body" *ngIf="accRelated">
          <table class="mwd-docs-table" *ngIf="task.relatedDocuments?.length">
            <thead><tr><th>Ref</th><th>Subject</th><th>Type</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let d of task.relatedDocuments" style="cursor:pointer"
                  (click)="d.documentNodeId && openDocInViewer(d.documentNodeId, d.referenceNumber)">
                <td style="font-family:monospace;font-weight:600">{{ d.referenceNumber }}</td>
                <td>{{ d.subject }}</td>
                <td>{{ d.mailType }}</td>
                <td>
                  <span *ngIf="d.documentNodeId" class="material-icons" style="font-size:16px;color:#4A90D9">
                    preview
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="!task.relatedDocuments?.length" class="mwd-empty">
            <span class="material-icons">link_off</span><span>No related documents.</span>
          </div>
        </div>
      </div>

      <!-- ══ AUDIT TRAIL ══ -->
      <div class="mwd-acc">
        <div class="mwd-acc-head" (click)="accAudit = !accAudit">
          <span class="material-icons">{{ accAudit ? 'expand_more' : 'chevron_right' }}</span>
          <span class="material-icons">history</span>
          <span class="mwd-acc-title">Audit Trail</span>
        </div>
        <div class="mwd-acc-body" *ngIf="accAudit">
          <div class="mwd-timeline">
            <div class="mwd-timeline-item" *ngFor="let a of task.auditTrail">
              <div class="mwd-t-marker">
                <span class="material-icons">{{ auditIcon(a.action) }}</span>
              </div>
              <div class="mwd-t-card">
                <div class="mwd-t-head">
                  <strong>{{ a.action }}</strong>
                  <span class="mwd-t-time">{{ a.actionTimestamp | date:'d MMM HH:mm' }}</span>
                </div>
                <p *ngIf="a.actorName || a.actorUsername">
                  by {{ a.actorName || a.actorUsername }}
                  <span *ngIf="a.fromStage && a.toStage"> · {{ a.fromStage }} → {{ a.toStage }}</span>
                </p>
                <p *ngIf="a.note" class="mwd-t-note">"{{ a.note }}"</p>
              </div>
            </div>
            <div *ngIf="!task.auditTrail?.length" class="mwd-empty">
              <span class="material-icons">history_toggle_off</span><span>No audit entries.</span>
            </div>
          </div>
        </div>
      </div>

    </div><!-- /mwd-right -->
  </div><!-- /mwd-split -->
</div><!-- /mwd-page -->

<ng-template #loadingTpl>
  <div class="mwd-loading">
    <div *ngIf="loading" style="text-align:center">
      <div class="mwd-spinner"></div>
      <p style="margin-top:12px;color:#6c757d">Loading task…</p>
    </div>
    <div *ngIf="!loading && error" style="text-align:center">
      <span class="material-icons" style="font-size:40px;color:#dc3545">error_outline</span>
      <p style="color:#dc3545">{{ error }}</p>
      <button class="sp-btn sp-btn-outline" (click)="loadTask()">Retry</button>
    </div>
  </div>
</ng-template>